export const RECEIVE_USER = 'RECEIVE_USER';
export const RECEIVE_USER_NOSSA = 'RECEIVE_USER_NOSSA';
export const LOGIN_NOSSA_USER = 'LOGIN_NOSSA_USER';
export const RECEIVE_TOKEN = 'RECEIVE_TOKEN';
export const ERROR_USER = 'ERROR_USER';
export const REMOVE_USER_ERRORS = 'REMOVE_USER_ERRORS';
export const LOGOUT_USER_ACTION = 'LOGOUT_USER_ACTION';
export const RESET_USER_ACTION = 'RESET_USER_ACTION';
export const IS_AUTHENTICATED = 'IS_AUTHENTICATED';
export const LOGOUT_USER = 'LOGOUT_USER';
export const LOADING_USER = 'LOADING_USER';
export const LOADING_USER_AUTHENTICATION = 'LOADING_USER_AUTHENTICATION';
export const REQUEST_USER_LINK_ACCOUNT = 'REQUEST_USER_LINK_ACCOUNT';
export const RECEIVED_USER_LINK_ACCOUNT = 'RECEIVED_USER_LINK_ACCOUNT';
export const ERROR_USER_LINK_ACCOUNT = 'ERROR_USER_LINK_ACCOUNT';
export const SET_USER_RECOVERING_ACCOUNT = 'SET_USER_RECOVERING_ACCOUNT';
export const SET_IS_EX_SUBSCRIBER = 'SET_IS_EX_SUBSCRIBER';

export function receiveUser(user, receivedToken = false, data = {}) {
  return {
    type: RECEIVE_USER,
    user,
    authenticated: true,
    receivedToken,
    data
  };
}

/* eslint-disable */
export function receiveUserNossa(user, receivedToken = false, uid = false, data = {}) {
  return {
    type: RECEIVE_USER_NOSSA,
    user,
    authenticated: true,
    receivedToken,
    data,
    token: receivedToken,
    uid
  };
}

/* eslint-disable */
export function receiveToken(token, data = {}, origin, loginType, receivedToken = true) {
  return {
    type: RECEIVE_TOKEN,
    token,
    data,
    origin,
    loginType,
    receivedToken
  };
}

export const loginNossaUser = user => ({
  type: LOGIN_NOSSA_USER,
  user,
  errors: null,
});

export function errorUser(errors) {
  return {
    type: ERROR_USER,
    errors
  };
}

export function removeUserErrors() {
  return {
    type: REMOVE_USER_ERRORS,
  };
}

export function isAuthenticated() {
  return {
    type: IS_AUTHENTICATED
  };
}

export function logoutUser() {
  return {
    type: LOGOUT_USER,
    user: {},
    token: null,
    authenticated: false
  };
}

export function logoutUserAction() {
  return {
    type: LOGOUT_USER_ACTION,
    userAction: 'logout'
  };
}

export function resetUserAction() {
  return {
    type: RESET_USER_ACTION,
  };
}

export function fetchingUser(loading) {
  return {
    type: LOADING_USER,
    loadingUser: loading
  };
}

export function fetchingUserAuthentication(loading) {
  return {
    type: LOADING_USER_AUTHENTICATION,
    loadingUserAuthentication: loading
  };
}

export function requestUserLinkAccount(cpf) {
  return {
    type: REQUEST_USER_LINK_ACCOUNT,
    cpf,
    loadingLinkAccount: true
  };
}

export function receivedLinkAccount(linkAccount) {
  return {
    type: RECEIVED_USER_LINK_ACCOUNT,
    linkAccount,
    loadingLinkAccount: false
  };
}

export function errorLinkAccount(linkAccountError) {
  return {
    type: ERROR_USER_LINK_ACCOUNT,
    linkAccountError,
    loadingLinkAccount: false
  };
}

export function setRecoveringAccount() {
  return {
    type: SET_USER_RECOVERING_ACCOUNT,
    isRecoveringAccount: true
  };
}

export function setIsExSubscriber(isExSubscriber) {
  return {
    type: SET_IS_EX_SUBSCRIBER,
    isExSubscriber,
  };
}
